"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmiliasKissOfSorrowAbilityHandler = exports.EmiliasKissOfSorrowActorAbilityFactory = exports.EmiliasKissOfSorrowAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Bleeding_1 = require("../../core/effects/core/Bleeding");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class EmiliasKissOfSorrowAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.EmiliasKissOfSorrow;
        this.__typeName = "EmiliasKissOfSorrow";
    }
}
exports.EmiliasKissOfSorrowAbilityArgs = EmiliasKissOfSorrowAbilityArgs;
let EmiliasKissOfSorrowActorAbilityFactory = class EmiliasKissOfSorrowActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("EmiliasKissOfSorrow", "OneEnemies", 1);
    }
};
EmiliasKissOfSorrowActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("EmiliasKissOfSorrow")
], EmiliasKissOfSorrowActorAbilityFactory);
exports.EmiliasKissOfSorrowActorAbilityFactory = EmiliasKissOfSorrowActorAbilityFactory;
let EmiliasKissOfSorrowAbilityHandler = class EmiliasKissOfSorrowAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        let targetIds = ability.args.target.actorIds.slice(0, 1);
        if (container.hasAttribute(ability.invokerId, "Charm_Vampire_1")) {
            targetIds = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        }
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            projectiles: targetIds.map(targetId => ({
                targetId,
                type: "HeartMissle",
                path: "line",
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 55)
                ],
            })),
            onHit(sequence, _attack, _damages, { targetId }) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new Bleeding_1.BleedingEffectArgs("Power", 10),
                        new core_1.BurningEffectArgs("Power", 10)
                    ].filter(Boolean), true)
                });
            }
        });
    }
};
EmiliasKissOfSorrowAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.EmiliasKissOfSorrow)
], EmiliasKissOfSorrowAbilityHandler);
exports.EmiliasKissOfSorrowAbilityHandler = EmiliasKissOfSorrowAbilityHandler;
